module.exports = __webpack_public_path__ + "img/banner.9f60e9bd.png";